import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
	name: "absolute",
	standalone: false
})
export class AbsolutePipe implements PipeTransform {
	public transform(value: string | number): number {
		return Math.abs(+value);
	}
}

@Pipe({
	name: "negativelToZero",
	standalone: false
})
export class NegativeToZeroPipe implements PipeTransform {
	public transform(value: string | number): number {
		return Math.max(0, +value);
	}
}
